module.exports = __webpack_public_path__ + "d0ba2ebf414d2e8619209db9b03d9bcb.fbx";